<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'

defineOptions({ inheritAttrs: false })

const props = defineProps<{ documentId: string | None; to: RouteLocationRaw; txt: stringI18n; modalTitle: stringI18n; onAccept?: () => void }>()

const data = shallowReactive({
  render: false,
  view: false,
  open: false,
})

const timer2 = useTimeout()
async function mouseenter(on: boolean) {
  if (!data.render && on) {
    data.render = true
    timer2.clear()
    await helpers.sleep(20)
    timer2.clear()
  }
  if (on) {
    timer2.set(() => {
      if (!data.view) data.open = true
    }, 100)
  } else {
    timer2.set(() => {
      data.open = false
    }, 300)
  }
}

function doAccept() {
  if (data.view) data.view = false
  if (data.open) data.open = false
  props.onAccept?.()
}

const elLink = useTemplateRef('elLink')
</script>

<template>
  <LinkUi ref="elLink" v-bind="$attrs" :txt :to target="_blank" @mouseenter.passive="mouseenter(true)" @mouseleave.passive="mouseenter(false)" />
  <LazyInputAggreeModals v-if="data.render" v-model:open="data.open" v-model:view="data.view" :elem="() => elLink" :title="modalTitle" :accept="() => doAccept()" :mouseenter :document-id />
</template>
